<template>
    <div>
        <message-component v-if="showError" :status="errorStatus" :message="errorMessage"></message-component>

        <div class="ticker-controls" v-if="! finished">
            <button class="ticker-btn" role="button" v-on:click="getNewCommentary" v-if="autoRefresh">Refreshing in {{ 45 - timer }}s</button>
            <button class="ticker-btn" role="button" v-on:click="getNewCommentary" v-else>Refresh</button>

            <button class="ticker-btn" role="button" v-on:click="toggleAutoRefresh" v-if="autoRefresh">AutoLoading ON</button>
            <button class="ticker-btn" role="button" v-on:click="toggleAutoRefresh" v-else>AutoLoading OFF</button>
        </div>

        <div :class="{'is-loading is-loading-dark': isLoading}"></div>
        <ul class="ticker">
            <transition-group name="ticker-list" tag="p">
                <commentary-list-item-component
                    class="ticker-list-item"
                    v-for="item in commentary"
                    v-bind:item="item"
                    v-bind:key="item.id"
                >
                </commentary-list-item-component>
            </transition-group>
        </ul>
    </div>
</template>

<script>
    let interval = null;

    import axios from 'axios'
    import CommentaryListItemComponent from './CommentaryListItemComponent.vue'
    export default {
        components: { CommentaryListItemComponent },
        props: ['fixture_id', 'message_error'],
        data() {
            return {
                commentary: [],
                showError: false,
                errorStatus: 'generic',
                errorMessage: '',
                isLoading: true,
                autoRefresh: true,
                lastTime: null,
                timer: 0,
                timerOn: true, // if we're s
                finished: false,
            }
        },
        mounted() {
            this.showError = false;
            this.isLoading = true;

            this.$nextTick(function () {
                this.getNewCommentary();
            });

            interval = setInterval(() => {
                this.timerTick();
            }, 1000);
        },
        methods: {
            timerTick() {
                if (this.timerOn) {
                    this.timer += 1;
                    // 45 seconds
                    if (this.timer >= 45 && this.autoRefresh) {
                        this.getNewCommentary();
                    }
                }
            },
            toggleAutoRefresh() {
                this.autoRefresh = ! this.autoRefresh;
            },
            getNewCommentary() {
                this.timerOn = false; // stop the timer until we get a response
                this.timer = 0; // reset it so that after we get a response, we'll start counting to 45 again.
                this.showError = false;

                // build request URI
                let endpoint = '/api/commentary/' + this.fixture_id;
                if (this.lastTime !== null) {
                    endpoint = endpoint + '/' + this.lastTime;
                }

                axios.get(endpoint).then((response) => {
                    this.timerOn = true;
                    this.isLoading = false;
                    this.lastTime = response.data.lastTime;
                    if (response.data.commentary.length > 0) {
                        this.commentary = response.data.commentary.concat(this.commentary);
                    }
                    if (response.data.finished === true) {
                        // stop any updates as the server tells us the match has finished
                        this.autoRefresh = false;
                        this.timerOn = false;
                        this.finished = true;
                        clearInterval(interval); // clear the timer interval
                    }
                }).catch(() => {
                    this.timerOn = true; // continue the timer so that we can try again in 45 secs
                    this.errorStatus = 'error';
                    this.errorMessage = this.message_error;
                    this.showError = true;
                });
            }
        },
         destroyed() {
            clearInterval(interval);
        }
    }
</script>
